import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/members.json';
import ar from './i18n/ar/members.json';

registerFeatureI18n('members', { en, ar });

export { MembersPage } from './MembersPage';
